import React, { useState } from "react";
import { SketchPicker } from "react-color";
import { useIntl } from "react-intl";
import { useDispatch } from "react-redux";
import IntlMessages from "@util/IntlMessages";
import { Button, Input, Message, Switch } from "../../../BP2Components";
import { setWidgetInSheetParams, updateWidgetSettings } from "../../../../appRedux/actions/Actions";
const ListWidgetSettings = (props) => {
   const [settings, setSettings] = useState({
      name: props.name,
      selectedSerie: props.selectedSerie,
      listWidgetSeries: props.listWidgetSeries,
      priority: props.priority,
      id: props.id,
      h: props.h,
      xsWidth: props.xs,
      smWidth: props.sm,
      mdWidth: props.md,
      lgWidth: props.lg,
      xlWidth: props.xl,
      backgroundColourHex: props.backgroundColourHex,
      mapLocalizationFieldName: props.localizationFieldName,
      mapClickFilterColName: props.mapClickFilterColName,
      mapDefaultZoomLevel: props.mapDefaultZoomLevel,
      mapViewListSerie: props.mapViewListSerie,
      mapListSerie: props.mapListSerie,
      mapIndependentSerie: props.mapIndependentSerie,
      mapPointColName: props.mapPointColName,
      mapDistanceColName: props.mapDistanceColName,
      mapAddressColName: props.mapAddressColName,
      showMap: props.showMap,
      filterByLocation: props.filterByLocation,
      distanceToFilter: props.distanceToFilter,
      maxDistanceToFilter: props.maxDistanceToFilter,
      setDistanceColumnHidden: props.setDistanceColumnHidden,
      showPlacefinder: props.showPlacefinder,
      showUrlButton: props.showUrlButton,
      urlColumn: props.urlColumn,
      ulrButtonTitle: props.ulrButtonTitle,
   });

   const intl = useIntl();

   const [displayColorPicker, setDisplayColorPicker] = useState(false);
   const dispatch = useDispatch();

   const handleChangeInput = (name) => (e) => {
      setSettings({ ...settings, [name]: +e.target.value });
   };

   const handleSubmit = (e) => {
      e.preventDefault();
      dispatch(setWidgetInSheetParams(settings));
      dispatch(updateWidgetSettings(settings));
      Message.success(intl.formatMessage({ id: "save.modal" }));
   };
   const handleClose = () => {
      setDisplayColorPicker(false);
   };
   const handleChangeColor = (color) => {
      setSettings({ ...settings, backgroundColourHex: color.hex });
   };
   const handleClick = () => {
      setDisplayColorPicker(!displayColorPicker);
   };
   const handleDefaultColor = () => {
      setSettings({ ...settings, backgroundColourHex: "#fff" });
   };

   const handleSwitch = (checked, name) => {
      setSettings({ ...settings, [name]: checked });
   };

   return (
      <form onSubmit={handleSubmit}>
         <div className="widget-settings">
            <div className="widget-settings__inner">
               <label key="showMap" className="widget-settings__inner__label">
                  <IntlMessages id="settings.showPlacefinder" />:
                  <Switch
                     name="showPlacefinder"
                     onChange={(e) => handleSwitch(e, "showPlacefinder")}
                     defaultChecked={props.showPlacefinder}
                  />
               </label>
               <label key="xsWidth" className="widget-settings__inner__label">
                  <IntlMessages id="settings.xsWidth" />:
                  <Input
                     type="number"
                     name="xsWidth"
                     onChange={handleChangeInput("xsWidth")}
                     min={1}
                     max={24}
                     defaultValue={props.xs}
                  />
               </label>
               <label key="smWidth" className="widget-settings__inner__label">
                  <IntlMessages id="settings.smWidth" />:
                  <Input
                     type="number"
                     name="smWidth"
                     onChange={handleChangeInput("smWidth")}
                     min={1}
                     max={24}
                     defaultValue={props.sm}
                  />
               </label>
               <label key="mdWidth" className="widget-settings__inner__label">
                  <IntlMessages id="settings.mdWidth" />:
                  <Input
                     type="number"
                     name="mdWidth"
                     onChange={handleChangeInput("mdWidth")}
                     min={1}
                     max={24}
                     defaultValue={props.md}
                  />
               </label>
               <label key="lgWidth" className="widget-settings__inner__label">
                  <IntlMessages id="settings.lgWidth" />:
                  <Input
                     type="number"
                     name="lgWidth"
                     onChange={handleChangeInput("lgWidth")}
                     min={1}
                     max={24}
                     defaultValue={props.lg}
                  />
               </label>
               <label key="xlWidth" className="widget-settings__inner__label">
                  <IntlMessages id="settings.xlWidth" />:
                  <Input
                     type="number"
                     name="xlWidth"
                     onChange={handleChangeInput("xlWidth")}
                     min={1}
                     max={24}
                     defaultValue={props.xl}
                  />
               </label>
               <label className="widget-settings__inner__label" key="priority">
                  <IntlMessages id="settings.priority" />:
                  <Input
                     type="number"
                     name="priority"
                     onChange={handleChangeInput("priority")}
                     min={1}
                     defaultValue={props.priority}
                  />
               </label>
               <label key="backgroundColourHex" className="widget-settings__inner__label">
                  <IntlMessages id="settings.backgroundColour" />:
                  <div>
                     <Button
                        onClick={handleClick}
                        className="cp-color"
                        style={{
                           backgroundColor: settings.backgroundColourHex,
                        }}
                     >
                        <IntlMessages id="settings.clickToChangeColor" />
                     </Button>
                     <Button onClick={handleDefaultColor}>
                        <IntlMessages id="settings.setDefaultColor" />
                     </Button>
                  </div>
                  {displayColorPicker ? (
                     <div className="cp-popover">
                        <div className="cp-cover" onClick={handleClose} />
                        <SketchPicker
                           color={
                              settings.backgroundColourHex !== null
                                 ? settings.backgroundColourHex
                                 : "#fff"
                           }
                           onChange={handleChangeColor}
                        />
                     </div>
                  ) : null}
               </label>
               <p>ID: {props.id}</p>
            </div>
         </div>
         <Button buttonType="primary" htmlType="submit" style={{ marginLeft: 30 }}>
            <IntlMessages id="global.preview" />
         </Button>
      </form>
   );
};

export default ListWidgetSettings;
